import "./index.css";
import { RouterProvider } from "react-router";
import { router } from "@/routes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
